
import {Component, Prop, Watch} from 'vue-property-decorator';
import DebounceMixin from '@/mixins/DebounceMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import {mixins} from 'vue-class-component';
import {ValidationObserver} from 'vee-validate';
import {swalSuccess, swalError} from '@/plugins/swal';
import {experienceModule} from '@/store/modules/job_experience';
import {SET_EXPERIENCE} from '@/store/mutationTypes';

@Component
export default class DialogArticle extends mixins(
  LoadingMixin,
  SnackbarMixin,
  DebounceMixin,
) {
  @Prop() value!: boolean;
  @Prop({default: ''}) id!: string | number;
  @experienceModule.Mutation(SET_EXPERIENCE) resetFilter!: Function;

  $refs!: {
    form: InstanceType<typeof ValidationObserver>;
  };

  data = '';
  searchProduct = '';
  formData = {
    position: '',
    company: '',
    description: '',
    city: '',
    start_date: null,
    end_date: null,
  };
  list_education_level: any = [];
  article: any = [];
  dialog = false;
  menu = false;
  menu2 = false;

  get rules() {
    return {
      position: 'required',
      company: 'required',
      description: '',
      city: 'required',
      start_date: 'required',
      end_date: 'required',
    };
  }
  @Watch('dialog')
  onDialogChanged(val: boolean) {
    this.$emit('input', val);
  }

  @Watch('value', {immediate: true})
  onValueChanged(val: boolean) {
    this.dialog = val;
  }
  @Watch('id', {immediate: true})
  onIdChanged(val: any) {
    if (val !== '') {
      this.fetchDetail();
    }
  }
  get isEditing() {
    return !!this.id;
  }
  async fetchDetail() {
    try {
      this.startLoading('detail');
      const res = await this.$store.dispatch(
        'jobExperience/getdetail',
        this.id,
      );
      this.formData = res.data.data;
      this.finishLoading('detail');
    } catch (e) {
      this.catchError(e);
    }
  }
  onSubmit() {
    if (this.id) {
      this.update();
    } else {
      this.create();
    }
  }

  async create() {
    try {
      this.startLoading('saving');
      const res = await this.$store.dispatch(
        'jobExperience/create',
        this.formData,
      );
      this.finishLoading('saving');
      if (res.status === 200) {
        swalSuccess.fire({
          title: 'Success!',
          text: res.data.message,
        });
        this.$emit('getExperience');
        this.close();
      } else {
        this.dialog = false;
        this.$dialog.error(res.error.message);
      }
    } catch (e) {
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
  async update() {
    try {
      this.startLoading('saving');
      const res = await this.$store.dispatch('jobExperience/update', {
        id: this.id,
        payload: this.formData,
      });
      if (res.status === 200) {
        this.finishLoading('saving');
        swalSuccess.fire({
          title: 'Success!',
          text: res.data.message,
        });
        this.$emit('getExperience');
        this.close();
      } else {
        this.finishLoading('saving');
        this.$dialog.error(res.error.message);
      }
    } catch (e) {
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }

  clear() {
    this.formData = {
      position: '',
      company: '',
      description: '',
      city: '',
      start_date: null,
      end_date: null,
    };
    this.id = '';
    this.$refs.form?.reset();
  }

  beforeDestroy() {
    this.resetFilter();
    this.clear();
  }

  close() {
    this.dialog = false;
    this.clear();
  }
}
